// extracted by mini-css-extract-plugin
export default {"root":"Timer_root__KxLQK","text":"Timer_text__-ZVdS","time":"Timer_time__-1DXu","subText":"Timer_subText__NrvJh","dividerTime":"Timer_dividerTime__IQA3i"};